<template>
  <div>
    <!-- picB848BA2024C92A1DD00F110463785826.jpg -->
    <img class="img-large rounded" src="@/assets/news-network/challenge-vehicle.jpg">
    <p>
      Professor Brickkeeper is searching for new inspiration! Your adventures in LEGO Universe may take you across muddy fields, rocky mountains, sandy dunes or city streets! To overcome the latest creative challenge, build your dream machines for getting around on the ground: <router-link :to="{ name: 'challenge', params: {id: 'A0EFDF27-AAF8-483F-BFA1-67918BE9C68A'} }">Launch a land vehicle</router-link>!
    </p>
  </div>
</template>
